<template>
    <List
        :config="{ ...config, component: componentTypes.List }"
    >
        <template #no-items>
            <Empty icon="empty-notifications">
                <template #title>
                    All caught up.
                </template>

                <template #subtitle>
                    You have no unread notifications.
                </template>
            </Empty>
        </template>
    </List>
</template>

<script setup>
    import List from '@/components/modules/List.vue'
    import Empty from '@/components/ui/Empty.vue'
    import componentTypes from '@/constants/componentTypes'

    const props = defineProps({
        config: Object,
    })
</script>
